module.exports = __webpack_public_path__ + "img/mohamad_farahani.18a7ec7.jpg";